<template>
  <div>
    <div v-if="addresses.length" class="vacancy-list-filter-address">
      <VCheckbox
        v-model="selected"
        v-for="address in addresses"
        :key="address.id"
        :value="address.id"
        hide-details
        class="vacancy-list-filter-address__item"
      >
        <template #label>
          <span class="vacancy-list-filter-address__label">{{ address.address }}</span>
        </template>
      </VCheckbox>
    </div>
    <template v-else>
      <VAlert color="error" outlined>
        {{ $t('empty') }}
      </VAlert>
    </template>
  </div>
</template>

<script>
import useCompany from '@/compositions/useCompany';
import {
  computed, toRefs,
} from '@vue/composition-api';

export default {
  name: 'VacanciesListDetailFilterAddress',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const { addresses } = useCompany();

    const selected = computed({
      get() {
        return value.value;
      },
      set(val) {
        emit('input', val);
      },
    });

    return {
      addresses,
      selected,
    };
  },
};
</script>

<style lang="scss" scoped>
  .vacancy-list-filter-address {
    padding: 0.3125rem 0 0 1.875rem;
    margin: -0.25rem 0 1.25rem;
    &__item {
      padding: 0.75rem 0;
      line-height: 1.25;
      color: #212121;
      border-bottom: 1px solid #EEEEEE;
      margin-bottom: 0;
      &:first-child {
        border-top: 1px solid #EEEEEE;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .vacancy-list-filter-address {
      padding-left: 0;
      &__item {
        padding: 0.625rem 0;
      }
      &__label {
        font-size: 0.875rem;
      }
    }
  }
</style>

<i18n lang="yml" locale="ru">
empty: Нет ни одной вакансии с заполненным адресом
</i18n>
<i18n lang="yml" locale="en">
empty: There are no jobs with an address specified
</i18n>
